<template>
    <div class="search-container">
        <i class="fas fa-search search-icon"></i>
        <input
            ref="searchInputRef"
            type="text"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            placeholder="Search user defined fields..."
            class="search-input"
        >
        <button v-if="modelValue" class="clear-search-button" @click="clearSearch" aria-label="Clear search">
            <Icon name="close" size="lg" color="var(--grayscale-500)" hover="var(--primary-700)"></Icon>
        </button>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Icon from '@common/icon/Icon.vue';

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['update:modelValue']);
const searchInputRef = ref(null);

const clearSearch = () => {
    emit('update:modelValue', '');
    searchInputRef.value?.focus();
};

onMounted(() => {
    searchInputRef.value?.focus();
});
</script>

<style scoped>
/* Search Bar */
.search-container {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: var(--space-6);
}

.search-icon {
    position: absolute;
    left: var(--space-4);
    top: 50%;
    transform: translateY(-50%);
    color: var(--grayscale-400);
}

.search-input {
    width: 100%;
    height: 100%;
    padding: var(--space-3) 2.5rem var(--space-3) 2.25rem;
    border: 1px solid var(--grayscale-300);
    border-radius: var(--radius-md);
    background: var(--surface-default);
    font-size: var(--text-size-md);
}

.search-input:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--primary-500);
    border-color: transparent;
}

.clear-search-button {
    position: absolute;
    right: var(--space-2);
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--space-1);
    border-radius: 50%;
    border: none;
    background: none;
    cursor: pointer;
}
</style>
